<template>
  <div class="bg-gray-200 tracking-wide">
    <div class="min-h-screen flex items-center justify-center">
      <div class="container">
        <div class="mb-12 w-full flex justify-center">
          <router-link to="/">
            <img :src="settingStore.siteLogo" alt="logo-img" class="h-8" />
          </router-link>
        </div>
        <div class="bg-white shadow rounded mb-6">
          <div class="grid md:grid-cols-12">
            <slot></slot>
          </div>
        </div>
        <auth-footer />
      </div>
    </div>
  </div>
</template>
<script setup>
import AuthFooter from "@/components/AuthLayout/AuthFooter.vue";
import { useSettingsStore } from "@/stores/settingStore";

const settingStore = useSettingsStore();
</script>
